import { produce } from 'immer';
import { createModel, RematchDispatch } from '@rematch/core';

import baseEntity from './base.entity';
import { RootModel } from '../models';
import { MapLocationTypes, TemplateCategoryTypes } from '../../types';
import { storeName as templateCategoryEntityStore } from './templateCategory.entity';

export const storeName = 'mapLocationEntity';

export const mapLocationEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
    saves: produce((state, entities: MapLocationTypes[]) => {
      (entities || []).forEach((entity) => {
        state.ids[entity.id] = entity;
      });
    }),
  },
  effects: (dispatch: RematchDispatch<typeof mapLocationEntity>) => ({
    async checkTemplateCategory(payload: MapLocationTypes[], state: RootModel) {
      const templateCategoryEntities = (state[templateCategoryEntityStore] as any).ids;

      this.saves(
        payload.map((item) => {
          const { mapLocationInfo } = item;

          if (
            mapLocationInfo &&
            mapLocationInfo.categories &&
            !!mapLocationInfo.categories.length
          ) {
            let { icon, iconBgColor } = mapLocationInfo;

            const category: TemplateCategoryTypes =
              templateCategoryEntities[mapLocationInfo.categories[0]];
            if (!category) return item;

            if (category.icon) icon = category.icon;
            if (category.iconBgColor) iconBgColor = category.iconBgColor;
            return { ...item, mapLocationInfo: { ...mapLocationInfo, icon, iconBgColor } };
          }

          return item;
        })
      );
    },
  }),
});

export default mapLocationEntity;
